<template>
  <div
    id="classificationConfirmationPopup"
    class="modal fade"
    :class="popupData.customClass"
    role="dialog"
  >
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-header generic-header">
          {{ title }}
          <img
            class="close-icon cursor-pointer"
            src="/static/images/icons/close_icon.svg"
            @click="$emit('closeConfirmationPopup', popupData.cancelButtonValue)"
            data-dismiss="modal"
            data-target="#classificationConfirmationPopup"
          />
        </div>
        <div class="modal-body pt-0">
          <div v-html="popupData.body"></div>
        </div>
        <div class="modal-footer">
          <template v-if="popupData.buttonsType === 'confirmation'">
            <button
              type="button"
              class="btn emergo-white-button wd-220"
              @click="$emit('closeConfirmationPopup', popupData.cancelButtonValue)"
              data-dismiss="modal"
              data-target="#classificationConfirmationPopup"
            >
              No, Cancel
            </button>
            <button
              type="button"
              class="btn emergo-green-button wd-220"
              @click="$emit('closeConfirmationPopup', popupData.confirmButtonValue)"
              data-dismiss="modal"
              data-target="#classificationConfirmationPopup"
            >
              Yes, Confirm
            </button>
          </template>
          <template v-else-if="popupData.buttonsType === 'normal'">
            <button
              type="button"
              class="btn emergo-green-button wd-220"
              data-dismiss="modal"
              data-target="#classificationConfirmationPopup"
              @click="$emit('closeConfirmationPopup', popupData.confirmButtonValue)"
            >
              OK
            </button>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['type', 'title', 'popupData'],
};
</script>
<style scoped>
.modal-content {
  border-radius: 10px;
}
.modal-header {
  padding: 25px 25px 10px;
  background: #fff;
  border-radius: 10px;
  border: 0;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 28px;
  color: #0b3c61;
}
.modal-footer {
  background: #fff;
  border-radius: 10px;
  border: 0;
  padding: 30px 35px;
}
.close-icon {
  position: absolute;
  top: 18px;
  right: 18px;
}
.modal-dialog .form-control.text-box {
  height: 150px;
  resize: none;
}
.info-icon {
  width: 58px;
  height: 58px;
}
.modal-body {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: justify;
  color: rgba(0, 0, 0, 0.7);
  margin: 0 35px;
  padding: 15px 0;
}
.modal-body .sub-header {
  color: rgba(0, 0, 0, 0.7);
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  padding-top: 25px;
  padding-bottom: 20px;
}
.submit-popup .modal-footer {
  padding: 30px 0px;
}
.submit-popup .modal-dialog {
  width: 480px;
}
.confirmation-popup .modal-dialog {
  width: 800px;
}
.confirmation-popup .modal-body {
  border-bottom: 1px solid #bdbdbd;
}
::v-deep .modal-note {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.7);
}
::v-deep ul.points {
  padding: 0px 0 5px 20px;
}
::v-deep ul.points li {
  padding-bottom: 5px;
}
::v-deep ul.points li::marker {
  color: #00518a;
  font-size: 20px;
}
::v-deep .wd-220 {
  width: 220px;
}
.modal-footer .btn + .btn {
  margin-left: 25px;
}
::v-deep .red {
  color: red;
}
@media screen and (max-width: 767px) {
  .submit-popup .modal-dialog,
  .confirmation-popup .modal-dialog {
    width: 90%;
  }
  .modal-footer .btn + .btn {
    margin: 0;
    margin-top: 10px;
  }
  .submit-popup .modal-body, .confirmation-popup .modal-body {
    margin: 0 25px;
  }
}
@media (min-width:768px) and (max-width: 1024px) {
  .submit-popup .modal-dialog,
  .confirmation-popup .modal-dialog {
    width: 90%;
  }
  .submit-popup .modal-body, .confirmation-popup .modal-body {
    margin: 0 35px;
  }
}
</style>
